import React, { useEffect, useState } from "react";
import completedImage from "../../assests/images/Completed.png";
import purchaseImage from "../../assests/images/Purchase.png";
import pendingImage from "../../assests/images/Pending.png";
import shippedImage from "../../assests/images/Shipped.png";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import TableListing from "../common/tableListing";
import { purchaseInvoiceServices } from "../../services/purchaseInvoiceServices";
import P2PDownload from "../common/p2pDownload";

const initialColumns = [
  { id: "invoiceNumber", label: "Invoice No", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT", isRedirect: true, redirectUrl:"/admin/Vendor-Purchase-Detail", redirectKeyName: "_id" },
  { id: "invoiceNumberSap", label: "Invoice Number (SAP)", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "fiscalYear", label: "Fiscal Year", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "documentDate", label: "Document Date", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "DATE" },
  { id: "postingDate", label: "Posting Date", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "DATE" },
  { id: "createdBy", label: "Created By", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },

  { id: "requestId", label: "Company Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT", },
  { id: "vendorName", label: "Vendor Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "vendorCode", label: "Vendor Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "currency", label: "Currency", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "taxCode", label: "Tax Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "termsOfPayment", label: "Terms of Payment", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "baseLinePaymentDate", label: "Base Line Payment Date", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "DATE" },
  { id: "gstPartner", label: "GST Partner", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  // { id: "col10", label: "Actions", isSort: true, sortLabel: "" },
];

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function ListingPurchase() {
  const [opencreateentry, setOpenCreateEntry] = useState(false);
  const [selectedListArr, setSelectedListArr] = useState([]);
  const [selectedPOJsonArr, setSelectedPOJsonArr] = useState([]);

  const [filterText, setFilterText] = useState("");
  const [filterFormData, setFilterFormData] = useState("");

  const onSelectedListChange = (param, jsonArr) => {
    // console.log(param);    
    setSelectedListArr(param);
    setSelectedPOJsonArr(jsonArr);
  }
  
  const onFilterChange = (formDataParam, textParam) => {
    setFilterFormData(formDataParam);
    setFilterText(textParam);
  }
  
  return (
    <>
      <div className="login-forms">
        <div
          className="text-centers row_purchase_invoice_dragdropcontext_apps_body"
        >
          <div>
            <div className="search_filter_outerse ms-auto">
              <div className="search_mains">
                <h5>Purchase Invoice Booking Listing</h5>
              </div>
              
              <P2PDownload
                url={`/v1/common/purchase-invoices/download`}
                selectedArr={selectedListArr}
                selectedPOJsonArr={selectedPOJsonArr}
                filterFormData={filterFormData}
                filterText={filterText}
                type="Purchase_Invoice"
              />

              {/* <div className="vendor_listing_lr_block_body">
                <button
                  // onClick={() => {
                  //   setOpenCreateEntry(true);
                  // }}
                  className="create_btn_lr_creations"
                >
                  Create PI
                </button>
              </div> */}
            </div>
            {/* <div className="account_ledger_listing_row1">
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total PI Booking
                    </label>
                    <p className="block_detail_listing">
                      <b>0</b>
                    </p>
                  </div>
            <img className="purchase_images_letscom"
                    src={purchaseImage}
                    alt=""
                  />
                </div>
              </div>
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total Pending PI
                    </label>
                    <p className="block_detail_listing">
                      <b>0</b>
                    </p>
                  </div>

        <img className="purchase_images_letscom"
                    src={pendingImage}
                    alt=""
                  />
                </div>
              </div>
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total Complete PI
                    </label>
                    <p className="block_detail_listing">
                      <b>0</b>
                    </p>
                  </div>
             <img className="purchase_images_letscom"
                    src={shippedImage}
                    alt=""
                  />
                </div>
              </div>
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total PI In Progress
                    </label>
                    <p className="block_detail_listing">
                      <b>0</b>
                    </p>
                  </div>
           <img className="purchase_images_letscom"
                    src={completedImage}
                    alt=""
                  />
                </div>
              </div>
            </div> */}
              
            <TableListing
                  column={initialColumns}
                  listingArrName="invoices"
                  filterKeyName="INVOICE"
                  componentName="PI_LIST"
                  promiseRequest={purchaseInvoiceServices?.getPurchaseInvoiceListing}
                  onSelectedListChange={onSelectedListChange}
                  onFilterChange={onFilterChange}
                  promiseUrlType="LIST"
                  additionalData={{
                    isTrackOrder: false,
                    isFilter: true,
                    isSearch: true,
                    isPagePerSize: true,
                    isPagination: true,
                    isDragable: true,
                  }}
              />
          </div>

          {/* Create GRN Modal */}
          <Modal
            open={opencreateentry}
            onClose={() => setOpenCreateEntry(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenCreateEntry(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_manager_bidding">
                  Are you sure you want to "<b>Create GRN</b>"
                  <br />
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenCreateEntry(false);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => setOpenCreateEntry(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default ListingPurchase;
